/* VEYRISSA_FOOTER_CURRENT_V1
   Static replacement for the former Advanced Code runtime. */
(function(){
  'use strict';

  function bind(){
    var root=document.getElementById('shopify-section-footer');
    if(!root||root.dataset.veyrissaFooterDisclosureBound==='true')return;
    root.dataset.veyrissaFooterDisclosureBound='true';

    var desktop=window.matchMedia('(min-width: 1024px)');
    var disclosures=Array.from(root.querySelectorAll('.footer__disclosure'));

    function sync(){
      disclosures.forEach(function(item){
        if(desktop.matches)item.setAttribute('open','');
        else item.removeAttribute('open');
      });
    }

    sync();
    if(desktop.addEventListener)desktop.addEventListener('change',sync);
    else if(desktop.addListener)desktop.addListener(sync);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});
  else bind();

  document.addEventListener('shopify:section:load',function(event){
    if(event.target&&event.target.id==='shopify-section-footer')bind();
  });
})();